import { render } from "./OrcamentosView.vue?vue&type=template&id=cf21912c"
import script from "./OrcamentosView.vue?vue&type=script&lang=js"
export * from "./OrcamentosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__